import { useEffect, useState } from 'react';
import AUX from '../../../../hoc/Aux_';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteArchiveMember,
  getMemberArchived,
  getMembersCSV,
  getMembersXLSX,
  restoreMember,
} from '../../../../redux/MainAction';
import moment from 'moment';
import PaginationComponent from '../../filters/PaginationComponent';
import { downloadCSV, downloadXLS } from '../../../../helpers/helpers';
import { Button } from 'reactstrap';
import { FaFileCsv, FaFileExcel } from 'react-icons/fa';

const MemberArchived = () => {
  const dispatch = useDispatch();
  const list = useSelector((state) => state.Webtracker.archivedUser);

  const [data, setData] = useState([]);
  const [page, setPage] = useState(1); // Current page
  const [totalPages, setTotalPages] = useState(0); // Total number of pages
  const itemsPerPage = 10;

  useEffect(() => {
    getList();
  }, [page]);

  const getList = () => {
    var data = {
      offset: (page - 1) * itemsPerPage,
      limit: itemsPerPage,
      showArchived: true,
    };
    dispatch(getMemberArchived(data));
  };

  useEffect(() => {
    if (list && list.rows) {
      setData(list?.rows);
      setTotalPages(Math.ceil(list?.count / itemsPerPage));
    }
  }, [list, page]);

  const toggleModal = (id) => {
    var data = {
      id: id,
    };
    dispatch(restoreMember(data));
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const deleteUser = (id) => {
    var dta = {
      id: id,
    };
    dispatch(deleteArchiveMember(dta));
  };

  async function downloadCSVHandler(isCSV) {
    const payload = {
      showArchived: true,
    };

    if (isCSV) {
      const csv = await dispatch(getMembersCSV(payload));
      downloadCSV(csv, 'Archived Members Report');
    } else {
      const xlsx = await dispatch(getMembersXLSX(payload));
      downloadXLS(xlsx, 'Archived Members Report');
    }
  }

  return (
    <AUX>
      <div className="">
        <div className="d-flex justify-content-end align-items-center mt-2 mb-2 w-full">
          <div
            className="d-flex justify-content-start align-items-center"
            style={{ gap: '10px' }}
          >
            <Button
              color="success"
              size="sm"
              className="mr-2 d-flex align-items-center"
              onClick={() => downloadCSVHandler(true)}
            >
              <FaFileCsv className="mr-1" /> CSV
            </Button>
            {/* <Button
              color="primary"
              size="sm"
              className="d-flex align-items-center"
              onClick={() => downloadCSVHandler()}
            >
              <FaFileExcel className="mr-1" /> XLSX
            </Button> */}
          </div>
        </div>

        <div style={{ overflowX: 'auto' }}>
          <table
            id="datatable"
            className="table dt-responsive nowrap table-vertical"
            width="100%"
            cellSpacing="0"
          >
            <thead>
              <tr>
                <th>No.</th>
                <th>Member</th>
                <th>Member Type</th>
                <th>Team</th>
                <th>Job Title</th>
                <th>Member Since</th>
                <th>Archived on</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {data?.length ? (
                data?.map((acts, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{idx + 1 + (page - 1) * itemsPerPage}</td>
                      <td>
                        <div>
                          <span className="border rounded p-1 text-white bg-info text-uppercase">
                            {acts.firstName.charAt(0)}
                            {acts.lastName.charAt(0)}
                          </span>
                          <span className="ml-1">
                            {acts.firstName} {acts.lastName}
                          </span>
                        </div>
                      </td>
                      <td>
                        <span>{acts?.userEmployeeRelation?.role}</span>
                      </td>
                      <td>
                        <span>{}</span>
                      </td>
                      <td>
                        <span>{}</span>
                      </td>
                      <td>
                        <span>
                          {moment(acts?.createdAt).format('MMMM Do YYYY')}
                        </span>
                      </td>
                      <td>
                        <span>
                          {moment(acts?.userEmployeeRelation?.updatedAt).format(
                            'MMMM Do YYYY'
                          )}
                        </span>
                      </td>
                      <td>
                        <div style={{ display: 'flex', gap: '10px' }}>
                          <i
                            className="mdi mdi-reload font-20 Edit_Icons"
                            style={{ cursor: 'pointer' }}
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Restore User"
                            onClick={() => toggleModal(acts?.id)}
                          ></i>
                          <i
                            className="fa fa-trash text-danger font-20 Edit_Icons"
                            style={{ cursor: 'pointer' }}
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Delete User"
                            onClick={() => deleteUser(acts?.id)}
                          ></i>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td> No Records Found</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              )}
              {/* Add other rows as needed */}
            </tbody>
          </table>
          <PaginationComponent
            count={totalPages}
            page={page}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </AUX>
  );
};

export default MemberArchived;
